import { Card, CardContent, Typography } from "@mui/material";
import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip } from "recharts";

const formatCurrency = (value, currency) =>
  `${currency}${Number(value / 100 || 0).toLocaleString(undefined, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

const formatNumber = (value) => Number(value || 0).toLocaleString();

export default function VerticalBarChart({ title, data, dataKey, currency }) {
  const isValue = dataKey === "value";

  return (
    <Card sx={{ borderRadius: 3 }}>
      <CardContent>
        <Typography variant="h6" sx={{ mb: 2 }}>
          {title}
        </Typography>

        <ResponsiveContainer width="100%" height={320}>
          <BarChart data={data} margin={{ top: 8, right: 8, left: 8, bottom: 8 }}>
            <XAxis dataKey="name" type="category" tick={{ fontSize: 11 }} />

            <YAxis
              type="number"
              tick={{ fontSize: 11 }}
              tickFormatter={(value) =>
                isValue ? `${currency}${Number(value / 100).toLocaleString()}` : formatNumber(value)
              }
            />

            <Tooltip
              formatter={(value) =>
                isValue ? formatCurrency(value, currency) : formatNumber(value)
              }
              contentStyle={{
                fontSize: 11,
                borderRadius: 8,
                padding: "8px 10px",
              }}
              labelStyle={{
                fontSize: 11,
                marginBottom: 4,
              }}
              itemStyle={{
                fontSize: 11,
              }}
            />

            <Bar dataKey={dataKey} fill="#111827" radius={[6, 6, 0, 0]} maxBarSize={40} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
